export default __webpack_public_path__ + "static/media/phone-call.706b88da.png";